<template>
  <v-sheet color="blue-grey-darken-4">
    <v-container>
      <v-row>
        <v-col>
          <h2 class="text-h5 text-sm-h4 text-center font-weight-bold">
            Certified collision repair center for these brands
          </h2>
        </v-col>
      </v-row>

      <v-row class="align-center justify-space-around flex-xl-nowrap">
        <LogoLink :image="logoChryslerWhite" alt="Chrysler" scale="100%" />
        <LogoLink :image="logoFiatWhite" alt="Fiat" scale="30%" />
        <LogoLink
          :image="logoGenesisWhite"
          alt="Genesis"
          caption="Genesis Certified Collision Repair Center"
          scale="100%"
        />
        <LogoLink :image="logoHyundaiWhite" alt="Hyundai" scale="50%" />
        <LogoLink :image="logoInfinitiWhite" alt="Infiniti" scale="80%" />
        <LogoLink :image="logoDodgeWhite" alt="Dodge" scale="100%" />
        <LogoLink :image="logoJeepWhite" alt="Jeep" scale="50%" />
        <LogoLink :image="logoKiaWhite" alt="Kia" scale="60%" />
        <LogoLink :image="logoNissanWhite" alt="Nissan" scale="50%" />
        <LogoLink :image="logoRamWhite" alt="Ram" scale="40%" />
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script setup lang="ts">
import logoChryslerWhite from '#root/assets/logos/logo-chrysler-white.png'
import logoDodgeWhite from '#root/assets/logos/logo-dodge-white.png'
import logoFiatWhite from '#root/assets/logos/logo-fiat-white.png'
import logoGenesisWhite from '#root/assets/logos/logo-genesis-white.png'
import logoHyundaiWhite from '#root/assets/logos/logo-hyundai-white.png'
import logoInfinitiWhite from '#root/assets/logos/logo-infiniti-white.png'
import logoJeepWhite from '#root/assets/logos/logo-jeep-white.png'
import logoKiaWhite from '#root/assets/logos/logo-kia-white.png'
import logoNissanWhite from '#root/assets/logos/logo-nissan-white.png'
import logoRamWhite from '#root/assets/logos/logo-ram-white.png'
</script>
